import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

class ProgressBar extends React.Component {
  constructor(props) {
    super(props)
  }

  onFinish = (e) => {
      this.props.onFinish()
  }

  onNext = (e) => {
    if(this.props.current < this.props.total) {
      this.props.onNext()
    }
  }

  onPrev = (e) => {
    if(this.props.current > 1) {
      this.props.onPrev()
    }
  }

  render() {
    const width = Math.ceil(this.props.current * (100.0 / this.props.total)) + "%"

    return(
      <div className="form-wizard__nav">
        <div className="prev-next">
          {this.props.current > 1 ?
            <a className="arrow-button prev btn-back btn" onClick={this.onPrev}>
              <img src="/wp-content/themes/canaan/assets/images/arrow-left.svg" alt="Prev arrow"/>
            </a>
            :
            <span></span>
          }
          {this.props.current == this.props.total ?
            <button className="button button-large btn-next" onClick={this.onFinish}>Finish</button>
            :
            <button className="button button-large btn-next" onClick={this.onNext}>Next</button>
          }
        </div>
        <div className="form-wizard__progress">
          <div className="progress-label mb-2 text-medium">
            Step <span className="wizard-step">{this.props.current}</span>/<span className="wizard-length">{this.props.total}</span>
          </div>
          <div className="progress">
            <div className="progress-bar" style={{width: width}}></div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProgressBar
